import { Record, List, Map, fromJS } from 'immutable'

export const TEMP_ID_KEY = "clientTempId"
export const TEMP_ID_KEY_PATH = ["attributes", TEMP_ID_KEY]

function parseRecipientStatuses(data) {
  return Map().withMutations((mutable) => {
    Map(data).reduce((result, status, userString) => {
      const [type, id] = userString.split(':')
      return result.setIn([type, parseInt(id)], status)
    }, mutable)
  })
}

export function parseMessage(data) {
  const { tags, cc, bcc, attachments, context, attributes, recipientStatuses, ...rest } = data
  return Message({
    tags: List(tags),
    cc: List(cc),
    bcc: List(bcc),
    attachments: List(attachments),
    attributes: fromJS(attributes) || Map(),
    context: fromJS(context) || Map(),
    recipientStatuses: parseRecipientStatuses(recipientStatuses),
    ...rest
  })
}

export const Message = Record({
  id: undefined,
  inboxId: undefined,
  type: undefined,
  orgId: undefined,
  tags: List(),
  cc: List(),
  bcc: List(),
  conversationId: undefined,
  customerId: undefined,
  authorId: undefined,
  replyToId: undefined,
  authorType: undefined,
  to: undefined,
  from: undefined,
  sender: undefined,
  subject: undefined,
  body: undefined,
  uuid: undefined,
  originalHtml: undefined,
  originalText: undefined,
  conversationEvent: undefined,
  attachments: List(),
  createdAt: undefined,
  updatedAt: undefined,
  layerUrl: undefined,
  attributes: Map(),
  deliveryChannel: undefined,
  contentType: undefined,
  context: undefined,
  isPreMessage: undefined,
  failed: false,
  recipientStatuses: Map(),
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/message/models.js